import { render, staticRenderFns } from "./DepartmentsEdit.vue?vue&type=template&id=3a243d8b&"
import script from "./DepartmentsEdit.vue?vue&type=script&lang=ts&"
export * from "./DepartmentsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a243d8b')) {
      api.createRecord('3a243d8b', component.options)
    } else {
      api.reload('3a243d8b', component.options)
    }
    module.hot.accept("./DepartmentsEdit.vue?vue&type=template&id=3a243d8b&", function () {
      api.rerender('3a243d8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DepartmentsEdit.vue"
export default component.exports